import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { AccountDeletionStatus } from '@architeia/api-client'

// KORA-125: the member's deletion state, owned in one place so the "Your data" page and the
// scheduled-deletion banner in the layout never disagree after a confirm or cancel. The API calls
// live in `useAccountDeletion`; this store only holds the last known answer.
export const useAccountDeletionStore = defineStore('accountDeletion', () => {
  const status = ref<AccountDeletionStatus | null>(null)
  return { status }
})
